
  import { Component, Vue, Prop } from 'vue-property-decorator'
  import { commonModule, appointmentsRecurrencesModule } from '@/store/modules/store-accessor'
  import dayjs from 'dayjs'

  @Component
  export default class DeleteRecurringAppointmentModal extends Vue {
    @Prop()
    payload!: any;

    isDeletingAppointment = false;

    async hideModal () {
      commonModule.hideModal();
    }

    async mounted() {
      commonModule.initSnackbar({});
    }

    async doDelete () {
      this.isDeletingAppointment = true;
      const deleteData = {
        recurrence_id: this.payload.appointment.recurrence_id,
        exception_date: dayjs(this.payload.appointment.scheduled_start).toISOString(),
        installation_id: this.payload.inSideview ? this.payload.appointment.installation_id : undefined,
      };

      await appointmentsRecurrencesModule.deleteAppointmentRecurrenceOccurrence(deleteData);

      this.hideModal()
    }
  };
  